import { Plus } from "lucide-react";
import type { TimelineProject, TimelineAction } from "@scroll/shared-types/timeline";
import { getTotalDuration } from "@scroll/shared-types/timeline-utils";
import AudioTrackBar from "./AudioTrackBar";

interface AudioTrackRowProps {
  project: TimelineProject;
  pixelsPerSecond: number;
  onDispatch: (action: TimelineAction) => void;
  onAddAudio: () => void;
}

export default function AudioTrackRow({
  project,
  pixelsPerSecond,
  onDispatch,
  onAddAudio,
}: AudioTrackRowProps) {
  const totalDuration = getTotalDuration(project);

  return (
    <div className="timeline-audio-track">
      <span className="timeline-track-label">Audio</span>
      {project.audioTracks.length === 0 ? (
        <button className="timeline-audio-add-btn" onClick={onAddAudio}>
          <Plus size={12} />
          <span>Add music</span>
        </button>
      ) : (
        <>
          {project.audioTracks.map((track) => (
            <AudioTrackBar
              key={track.id}
              track={track}
              pixelsPerSecond={pixelsPerSecond}
              totalDuration={totalDuration}
              onDispatch={onDispatch}
            />
          ))}
          <button
            className="timeline-audio-add-btn timeline-audio-add-btn-small"
            onClick={onAddAudio}
            title="Add another track"
          >
            <Plus size={10} />
          </button>
        </>
      )}
    </div>
  );
}
